import i18n from "components/i18n/i18n";
import { CheckedPropertyInfo } from "../tableStatus";

const template = document.createElement("template");

template.innerHTML = `
  <style>
  .column {
    margin: 0 5px;
    display: inline-block;
  }
  .columnTitle {
      background-color: #ccc;
      padding: 1px 4px 0px 5px;
      border: 1px solid #ccc;
      border-right: none;
      border-radius: 5px 0 0 5px;
      margin: 0;
      display: inline-block;
  }
  .value {
    padding: 1px 4px 0px 3px;
    border: 1px solid #ccc;
    border-left: none;
    border-radius: 0 5px 5px 0;
    margin: 0;
    display: inline-block;
  }
  .length,
  .status {
      font-weight: bold;
  }
  </style>
  <span class="column">
  <span class="columnTitle"></span><span class="value">
  <span class="status"></span><span class="length"></span></span>
  </span>
`;

export class CheckInfoColumnElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.appendChild(template.content.cloneNode(true));
    }

    public set info(info: CheckedPropertyInfo) {
        let length = Object.keys(info.checked).length;
        (this._shadowRoot.querySelector(".columnTitle") as HTMLElement).innerText =
            i18n.t(this.getAttribute("labelKey"));
        if (length > 0) {
            (this._shadowRoot.querySelector(".length") as HTMLElement).innerText = length.toString();
        }
        if (info.state?.status === "all-checked" && !info.isComplete) {
            (this._shadowRoot.querySelector(".status") as HTMLElement).innerText = "todos";
        }
        if (info.state?.status === "some-unchecked") {
            (this._shadowRoot.querySelector(".status") as HTMLElement).innerText = "todos menos ";
        }
    }

    public static mustBeDrawn(info: CheckedPropertyInfo) {
        return (info.state?.status === "all-checked" && !info.isComplete)
            || Object.keys(info.checked).length > 0;
    }
}

export function initTableCheckInfoColumnWebComponent() {
    window.customElements.define("table-check-info-column", CheckInfoColumnElement);
}
